import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { $t } from '../../../i18n'
import { isTaskCompleted } from '../../../utils/onBoardingUtils'
import { DOWNLOAD_APP } from '../../../consts/OnBoardingConsts'
import Actions from '../../../actions'
import dayjs from 'dayjs'
import { getIsHmoMember } from '../../../utils/hmoUtils'

import './InviteToAppLabelAction.css'

export const InviteToAppLabelAction = ({ className, patientId }) => {
  const dispatch = useDispatch()
  const { members } = useSelector(state => state.account)
  const userDetails = useSelector(state => state.profile.userDetails)

  const isSelf = userDetails?.id?.toString() === patientId?.toString()

  const isOwnerHmo = !!getIsHmoMember(userDetails)

  const currentPatient = isSelf
    ? userDetails
    : members?.find(
        patient => patient?.id?.toString() === patientId?.toString()
      )
  const isInsured = currentPatient?.hmo_member_id || isOwnerHmo
  const patientTasks = currentPatient?.hmo_data?.on_boarding_tasks
  const isDownloadedApp =
    isTaskCompleted(patientTasks, DOWNLOAD_APP.name) || isSelf

  const TWO_WEEKS = 2
  const nowTime = dayjs.utc()
  const invitationDate = dayjs(currentPatient?.app_link_invitation_date)
  const isInvitedToApp =
    !!currentPatient?.app_link_invitation_date &&
    nowTime.diff(invitationDate, 'w') < TWO_WEEKS

  if (!isInsured || isDownloadedApp) return null

  const onInviteToAppPressed = e => {
    e.stopPropagation()
    dispatch(
      Actions.createAction(Actions.INVITE_HMO_MEMBER_TO_DOWNLOAD_APP_PRESSED, {
        patientId,
      })
    )
  }

  return (
    <div
      className={
        isInvitedToApp
          ? `invite-app-label ${className}`
          : `invite-app-label trackable clickable ${className}`
      }
      data-name="invite-app-label"
      onClick={isInvitedToApp ? () => {} : onInviteToAppPressed}
    >
      <span className="invite-app-text tiny semi-bold">
        {isInvitedToApp ? (
          $t('pages.inviteApp.invitationSent') + '!'
        ) : (
          <>
            {$t('common.inviteToApp')} <i className="icon-big-plus" />
          </>
        )}
      </span>
    </div>
  )
}

export default InviteToAppLabelAction
